import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=d557fc22&scoped=true&"
import script from "./search-box.vue?vue&type=script&lang=ts&"
export * from "./search-box.vue?vue&type=script&lang=ts&"
import style0 from "./search-box.vue?vue&type=style&index=0&id=d557fc22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d557fc22",
  null
  
)

export default component.exports